import styled, { css } from 'styled-components';
import Icon from '../Icon';

export const StyledCalendarWrapper = styled.div`
    padding: 15px 10px 0 10px;
    margin-left: -10px;
    margin-right: -10px;
    background: ${({ theme }) => theme.whiteTwo};
`

export const StyledCalendar = styled.div`
    position: relative;
`

export const StyledCalendarHeader = styled.div`
    ${({ fullContent }) =>
        fullContent &&
        css`
            padding: 0 15px;
        `
    };
`;

export const StyledCalendarMonth = styled.div`
    font-size: 13px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    color: ${({ theme }) => theme.greyishBrown};
    text-transform: uppercase;
    letter-spacing: 0.5px;
`

export const StyledCalendarBody = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    position: relative;
    border-bottom: 2px solid ${ ({ theme }) => theme.veryLightPink};
    ${({ fullContent }) =>
        fullContent &&
        css`
            padding: 0 15px;
        `
    };
`;

export const StyledCalendarDays = styled.div`
    display: flex;
    flex-basis: 55%;
    max-width: 200px;
    margin-top: 12px;
    margin-bottom: 8px;
`

export const StyledCalendarDayName = styled.div`
    font-size: 13px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

export const StyledCalendarDayNumber = styled.div`
    font-size: 13px;
    margin-top: 4px;
`;

export const StyledCalendarDay = styled.div`
    flex-basis: 40px;
    flex-shrink: 0;
    // text-align: center;
    margin-right: 10px;
    ${({ today }) =>
        today &&
        css`
            position: relative;
            ${StyledCalendarDayName} {
                color: ${({ theme }) => theme.grassyGreen};
                font-weight: ${({ theme }) => theme.fontWeight.bold};
            }

            ${StyledCalendarDayNumber} {
                font-weight: ${({ theme }) => theme.fontWeight.bold};
            }

            &::after {
                content: '';
                display: block;
                width: 100%;
                height: 2px;
                background-color: ${({ theme }) => theme.grassyGreen};
                position: absolute;
                bottom: -10px;
                z-index: 2;
            }
        `
    };
`

export const StyledCalendarButtons = styled.div`
    flex-basis: 25%;
    max-width: 100px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 10px;
    margin-left: 20px;
`

export const StyledCalendarButton = styled.div`

`

export const StyledIcon = styled(Icon).attrs(({ theme, disabled }) => ({
    color: disabled ? theme.veryLightPink : theme.grassyGreen,
    height: '20px'
}))`
    pointer-events: ${({ disabled }) => disabled ? 'none' : 'auto'};
    transform: ${({ direction }) => direction === "left" ? 'rotate(180deg)' : 'rotate(0deg)'};
    cursor: pointer;
`

export const StyledCalendarContent = styled.div`
  ${({ fullContent }) =>
        fullContent &&
        css`
            background: ${({ theme }) => theme.background};
            margin-left: -10px;
            margin-right: -10px;
            padding: 5px 10px;
        `
    };
     ${({ scrollContent }) => 
        scrollContent && 
        css`
            max-height: calc(100vh - 100px - 84px);
            overflow-y: scroll;
        `
    };
`;